import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./Components/Body/body";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Body />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;